import { render, staticRenderFns } from "./PersonPhoneNumbersTable.vue?vue&type=template&id=62793b9d&scoped=true&"
import script from "./PersonPhoneNumbersTable.vue?vue&type=script&lang=js&"
export * from "./PersonPhoneNumbersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62793b9d",
  null
  
)

export default component.exports